import React from "react";
import "./Template_1.css";

const Template_1_HeroSection = () => {
  const travelData = [
    {
      image:
        "https://images.unsplash.com/photo-1469474968028-56623f02e42e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80",
      title: "Mountain Peaks",
      description:
        "Experience the thrill of high altitudes and breathtaking views",
    },
    {
      image:
        "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80",
      title: "Tropical Beaches",
      description: "Relax on pristine sandy shores with crystal clear waters",
    },
    {
      image:
        "https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80",
      title: "Northern Lights",
      description: "Witness nature's most spectacular light show in the Arctic",
    },
    {
      image:
        "https://images.unsplash.com/photo-1505832018823-50331d70d237?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1508&q=80",
      title: "European Cities",
      description: "Explore historic architecture and vibrant cultures",
    },
    {
      image:
        "https://images.unsplash.com/photo-1418065460487-3e41a6c84dc5?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80",
      title: "Ancient Forests",
      description: "Discover lush greenery and peaceful walking trails",
    },
    {
      image:
        "https://images.unsplash.com/photo-1473496169904-658ba7c44d8a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80",
      title: "Desert Adventures",
      description: "Experience the magic of vast sand dunes and starry nights",
    },
    {
      image:
        "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80",
      title: "Tropical Islands",
      description: "Escape to paradise with pristine beaches and blue waters",
    },
  ];

  return (
    <div className="Template_1 travel-showcase">
      <div className="Template_1 header">
        <h1>Discover Your Next Journey</h1>
        <p>
          Explore breathtaking destinations around the world and find your
          perfect adventure
        </p>
      </div>

      <div className="Template_1 travel-grid">
        {travelData.map((item, index) => (
          <div
            key={index}
            className={`Template_1 travel-card Template_1 card-${index + 1}`}
          >
            <div className="Template_1 image-container">
              <img src={item.image} alt={item.title} />
            </div>
            <div className="Template_1 card-content">
              <h3>{item.title}</h3>
              <p>{item.description}</p>
              <a href="#" className="Template_1 explore-btn">
                Explore
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Template_1_HeroSection;
